<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn_190" prop="deptLevelCodes">
      <el-input clearable placeholder="工作单位" v-model="filters.deptNames" @focus="showDeptModal"
        @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input prefix-icon="el-icon-search" v-model="filters.userName" placeholder="姓名"></el-input>
    </el-form-item>

    <el-form-item>
      <el-input prefix-icon="el-icon-search" v-model="filters.mobile" placeholder="手机号"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
     <!--选调弹窗-->
    <SearchLazyTree
      ref="lazyTree"
      :defaultCheckedKeys="defaultCheckedKeys"
      :showTooltip="true"
      :deptDialog="deptDialog"
      @selectDept="selectDept"
    />
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import SearchLazyTree from "@/components/tree/searchLazyTree.vue";
export default {
  name: "search",
  components: {
    butn, SearchLazyTree
  },
  data() {
    return {
      size: "small",
      filters: {
        deptNames: '',
        deptLevelCodes: [],
        userName: "",
        mobile: '',
      },
      deptDialog: {
        flag: false,
      },
      defaultCheckedKeys: []
    };
  },
  created() {
  },
  methods: {
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },

    // 工作单位选择确定
    selectDept(data) {
      this.filters.deptNames = data.deptNames;
      this.filters.deptLevelCodes = data.deptLevelCodes;
      this.defaultCheckedKeys = data.nodeKeys;
      this.deptDialog = {
        flag: false,
      };
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodes = [];
      this.filters.deptNames = '';
       this.$nextTick(() => {
        this.$refs.lazyTree.$refs["tree"].setCheckedKeys([]);
      });
    },

    initData() {
      let params = {
        ...this.filters,
        t: new Date().getTime(),
      }
      delete params.deptNames
      this.$emit("search", params);
    },
    resetData() {
      this.clearDepts();
      this.filters = {};
      this.$emit("search", {
        t: new Date().getTime(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pro_select {
  width: 120px;
}

.pro_input {
  width: 120px;
  margin-right: 10px;
  margin-left: -10px;
}
</style>
